/**
 * Added to all addons in the planner that
 * can be purchased but not seen in the scene
 */
class AddonComponent {
    constructor() {
        this.typeId = AddonComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return false;
    }
}
AddonComponent.id = 2092;
export default AddonComponent;
//# sourceMappingURL=AddonComponent.js.map